import React from 'react';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <section className="hero">
        <h1>Welcome to 42 Pets</h1>
        <p className="tagline">Creating decent apps for decent people.</p>
      </section>

      <section className="intro">
        <div className="content-wrapper">
          <h2>Who We Are</h2>
          <p>
            42 Pets is dedicated to building mobile applications that solve simple problems.
          </p>
        </div>
      </section>

      <section className="features">
        <div className="content-wrapper">
          <h2>What We Do</h2>
          <div className="feature-grid">
            <div className="feature-card">
              <h3>🐾 Innovative Apps</h3>
              <p>We create intuitive mobile applications designed specifically for pet owners</p>
            </div>
            <div className="feature-card">
              <h3>📱 iOS First</h3>
              <p>Native iOS experiences that feel right at home on your device</p>
            </div>
            <div className="feature-card">
              <h3>❤️ Pet-Focused</h3>
              <p>Every feature is designed with the well-being of your pets in mind</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta">
        <div className="content-wrapper">
          <h2>Ready to Explore?</h2>
          <p>Check out our apps and discover how we can help you and your pets</p>
          <a href="/apps" className="cta-button">View Our Apps</a>
        </div>
      </section>
    </div>
  );
}

export default Home;
